export const ATTRIBUTES = 'ATTRIBUTES';
export const BUDGET = 'BUDGET';
export const CLEAR = 'CLEAR';
export const PREFERENCES = 'PREFERENCES';
export const SELECT_CATEGORY = 'SELECT_CATEGORY';
export const SELECT_ATTRIBUTE = 'SELECT_ATTRIBUTE';
